// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Comfortaa&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gugi&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@-webkit-keyframes colorPickerWidth {
  100% {
    width: 12.5rem;
  }
}
@keyframes colorPickerWidth {
  100% {
    width: 12.5rem;
  }
}
@-webkit-keyframes contentSlideDown {
  0% {
    -webkit-transform: translateY(-2rem);
            transform: translateY(-2rem);
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes contentSlideDown {
  0% {
    -webkit-transform: translateY(-2rem);
            transform: translateY(-2rem);
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@-webkit-keyframes contentSlideUp {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-2rem);
            transform: translateY(-2rem);
  }
}
@keyframes contentSlideUp {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-2rem);
            transform: translateY(-2rem);
  }
}
@-webkit-keyframes loaderScale {
  50% {
    -webkit-transform: scale(1%);
            transform: scale(1%);
  }
  100% {
    -webkit-transform: scale(100000%);
            transform: scale(100000%);
  }
}
@keyframes loaderScale {
  50% {
    -webkit-transform: scale(1%);
            transform: scale(1%);
  }
  100% {
    -webkit-transform: scale(100000%);
            transform: scale(100000%);
  }
}
@-webkit-keyframes loaderStroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes loaderStroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@media screen and (min-width: 320px) {
  #about {
    padding: 6rem 2.5rem !important;
  }
  .color {
    display: block !important;
  }
  .color-picker {
    -webkit-animation: colorPickerWidth 150ms forwards ease-in-out;
            animation: colorPickerWidth 150ms forwards ease-in-out;
    display: block !important;
  }
  .cube__wrapper {
    left: 10% !important;
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
  }
  .skill {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
        -ms-flex-direction: row !important;
            flex-direction: row !important;
  }
}
@media screen and (min-width: 480px) {
  #about {
    padding: 5rem 4rem !important;
  }
  .cube__wrapper {
    left: 15% !important;
  }
  .logo__text {
    display: block !important;
  }
  .menu button {
    font-size: 0.875rem !important;
  }
}
@media screen and (min-width: 541px) {
  #about {
    grid-template-columns: 1fr 2fr !important;
    padding: 3.25rem 4rem 4rem 2rem !important;
  }
  #about__content {
    max-height: 100% !important;
  }
  .cube__wrapper {
    bottom: 45% !important;
    left: 5% !important;
  }
  .pyramid__wrapper {
    bottom: 20% !important;
    right: 5% !important;
  }
  #skills {
    -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
            justify-content: center !important;
    padding: 2rem 0 2.5rem 0 !important;
  }
  #skills__content {
    width: 60% !important;
  }
  #skills__content .icon {
    margin: 0 1rem !important;
  }
  .sphere {
    right: 25% !important;
    top: 17.5% !important;
  }
}
@media screen and (min-width: 1024px) {
  #about__content {
    padding: 12.5% !important;
    min-height: calc(100vh - 6rem);
    min-height: calc(100vh - var(--shapeSize));
  }
  .cube__wrapper {
    bottom: 30% !important;
    left: 10% !important;
  }
  .email {
    font-size: 4vw !important;
  }
  .pyramid__wrapper {
    bottom: 15% !important;
    right: 15% !important;
    -webkit-transform: scale(1.5);
            transform: scale(1.5);
  }
  #shapes .title {
    font-size: 2.8125rem !important;
  }
  #skills__content {
    width: 50% !important;
  }
  #skills__content .icon {
    margin: 0 1.5rem !important;
  }
  .sphere {
    height: calc(6rem * 1.15) !important;
    height: calc(var(--shapeSize) * 1.15) !important;
    right: 20% !important;
    top: 15% !important;
    width: calc(6rem * 1.15) !important;
    width: calc(var(--shapeSize) * 1.15) !important;
  }
}
@media screen and (min-width: 1441px) {
  #about__content,
  #skills {
    padding: 0 !important;
  }
}
@media screen and (max-height: 320px) {
  .cube__wrapper {
    bottom: 40% !important;
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  .pyramid__wrapper {
    bottom: 10% !important;
  }
  .sphere {
    right: 12.5% !important;
    top: 20% !important;
  }
}
@media screen and (min-height: 576px) {
  .cube__wrapper {
    bottom: 25% !important;
  }
  .pyramid__wrapper {
    bottom: 10% !important;
  }
}
@media screen and (min-height: 1024px) {
  #about {
    padding: 25% 10% !important;
  }
  .cube__wrapper {
    bottom: 35% !important;
    left: 15% !important;
  }
  .pyramid__wrapper {
    bottom: 15% !important;
    right: 20% !important;
    -webkit-transform: scale(1.5) !important;
            transform: scale(1.5) !important;
  }
  #shapes .title {
    font-size: 2.8125rem !important;
  }
  .sphere {
    height: calc(6rem * 1.15) !important;
    height: calc(var(--shapeSize) * 1.15) !important;
    top: 22.5% !important;
    width: calc(6rem * 1.15) !important;
    width: calc(var(--shapeSize) * 1.15) !important;
  }
}
:root {
  --colorBgPrimary: rgb(37, 41, 50);
  --colorBgSecondary: rgba(117, 117, 162, 0.6);
  --colorContent: rgb(255, 255, 255);
  --colorShadow: rgba(0, 0, 0, 0.2);
  --cubeSideTranslateZ: 0rem;
  --pyramidTransform: rotateY(-45deg) rotateZ(-30deg);
  --shapeSize: 6rem;
  --vh: 100%;
}

body {
  background: rgb(37, 41, 50);
  background: var(--colorBgPrimary);
  color: rgb(255, 255, 255);
  color: var(--colorContent);
  font-family: "Comfortaa", cursive;
  font-size: 0.875rem;
  min-height: 100vh;
  min-height: 100%;
  min-height: var(--vh);
  overflow: hidden;
}

a {
  color: rgb(255, 255, 255);
  color: var(--colorContent);
}

button {
  background: none;
  border: none;
  color: rgb(255, 255, 255);
  color: var(--colorContent);
  cursor: pointer;
  font-family: "Comfortaa", cursive;
}

header {
  position: fixed;
  width: 100%;
  z-index: 1;
}

main {
  height: 100vh;
  height: 100%;
  height: var(--vh);
  overflow: hidden;
  position: relative;
}

p {
  line-height: 1.4;
}

section {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  opacity: 0;
  position: absolute;
  visibility: hidden;
  width: 100%;
}
section > div {
  padding: 0 1rem;
}
section .section--top {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

ul {
  list-style: none;
}

::-webkit-scrollbar {
  width: 0.2rem;
}
::-webkit-scrollbar-thumb {
  background: rgba(117, 117, 162, 0.6);
  background: var(--colorBgSecondary);
  border-radius: 0.5rem;
}

* {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#about {
  -webkit-box-align: initial;
      -ms-flex-align: initial;
          align-items: initial;
  display: grid;
  grid-template-columns: 0 1fr;
  padding: 4.5rem 1rem;
  text-align: justify;
}
#about__content {
  max-height: 60%;
  overflow-y: auto;
}

.back__btn {
  margin-top: 2rem;
}

.color-picker {
  border-radius: 0.3rem;
  display: none;
  height: 2rem;
  overflow: hidden;
  position: relative;
  -webkit-transition: all 150ms ease-out;
  transition: all 150ms ease-out;
  width: 0;
}
.color-picker canvas {
  height: 100%;
  width: 100%;
}
.color-picker .pointer {
  background: rgba(117, 117, 162, 0.6);
  background: var(--colorBgSecondary);
  height: 100%;
  left: 0.5rem;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  width: 1rem;
}

#contact .email {
  display: block;
  font-size: 5vw;
}

.cube__wrapper {
  bottom: 15%;
  left: 0;
  -webkit-perspective: 100rem;
          perspective: 100rem;
  -webkit-perspective-origin: 50% -250%;
          perspective-origin: 50% -250%;
  position: absolute;
}
[data-section] .cube__wrapper {
  display: none;
}
[data-section=about] .cube__wrapper {
  display: block;
}

.cube {
  height: 6rem;
  height: var(--shapeSize);
  position: relative;
  -webkit-transform: rotateY(-30deg);
          transform: rotateY(-30deg);
  -webkit-transform-style: preserve-3d;
          transform-style: preserve-3d;
  width: 6rem;
  width: var(--shapeSize);
}
.cube .cube__side {
  border: 0.15rem solid rgb(255, 255, 255);
  border: 0.15rem solid var(--colorContent);
  height: 100%;
  position: absolute;
  -webkit-transition: -webkit-transform 250ms ease-in-out;
  transition: -webkit-transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out, -webkit-transform 250ms ease-in-out;
  width: 100%;
}
.cube .cube__side--back {
  top: 50%;
  -webkit-transform: translateZ(calc(-1 * (6rem / 2 + 0rem)));
          transform: translateZ(calc(-1 * (6rem / 2 + 0rem)));
  -webkit-transform: translateZ(calc(-1 * (var(--shapeSize) / 2 + var(--cubeSideTranslateZ))));
          transform: translateZ(calc(-1 * (var(--shapeSize) / 2 + var(--cubeSideTranslateZ))));
}
.cube .cube__side--bottom {
  top: 100%;
  -webkit-transform: rotateX(90deg) translateZ(calc(-1 * 0rem));
          transform: rotateX(90deg) translateZ(calc(-1 * 0rem));
  -webkit-transform: rotateX(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));
          transform: rotateX(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));
}
.cube .cube__side--front {
  top: 50%;
  -webkit-transform: translateZ(calc(6rem / 2 + 0rem));
          transform: translateZ(calc(6rem / 2 + 0rem));
  -webkit-transform: translateZ(calc(var(--shapeSize) / 2 + var(--cubeSideTranslateZ)));
          transform: translateZ(calc(var(--shapeSize) / 2 + var(--cubeSideTranslateZ)));
}
.cube .cube__side--left {
  right: 50%;
  top: 50%;
  -webkit-transform: rotateY(90deg) translateZ(calc(-1 * 0rem));
          transform: rotateY(90deg) translateZ(calc(-1 * 0rem));
  -webkit-transform: rotateY(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));
          transform: rotateY(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));
}
.cube .cube__side--right {
  left: 50%;
  top: 50%;
  -webkit-transform: rotateY(90deg) translateZ(0rem);
          transform: rotateY(90deg) translateZ(0rem);
  -webkit-transform: rotateY(90deg) translateZ(var(--cubeSideTranslateZ));
          transform: rotateY(90deg) translateZ(var(--cubeSideTranslateZ));
}
.cube .cube__side--top {
  -webkit-transform: rotateX(90deg) translateZ(0rem);
          transform: rotateX(90deg) translateZ(0rem);
  -webkit-transform: rotateX(90deg) translateZ(var(--cubeSideTranslateZ));
          transform: rotateX(90deg) translateZ(var(--cubeSideTranslateZ));
}

.cursor {
  border: 0.15rem solid rgb(255, 255, 255);
  border: 0.15rem solid var(--colorContent);
  border-radius: 50%;
  display: none;
  height: 2rem;
  pointer-events: none;
  position: fixed;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: 150% 150%;
          transform-origin: 150% 150%;
  -webkit-transition: all 150ms ease-out;
  transition: all 150ms ease-out;
  width: 2rem;
  z-index: 2;
}
.cursor::before {
  background: rgb(255, 255, 255);
  background: var(--colorContent);
  border-radius: 50%;
  content: "";
  height: 0.3rem;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  width: 0.3rem;
}
.cursor--active {
  background: rgb(255, 255, 255);
  background: var(--colorContent);
  mix-blend-mode: soft-light;
  -webkit-transform: scale(1.5);
          transform: scale(1.5);
}
.cursor--active::before {
  display: none;
}

.header__content {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin: 1.75rem 1.75rem 0 1.75rem;
}
.header__content, .header__content > div {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.header__content--left {
  font-size: 1rem;
}
.header__content--left a {
  height: 2rem;
}
.header__content .color {
  background: linear-gradient(-45deg, rgba(117, 117, 162, 0.6), rgb(255, 255, 255));
  background: linear-gradient(-45deg, var(--colorBgSecondary), var(--colorContent));
  border-radius: 50%;
  display: none;
  height: 1rem;
  margin: 0 1.5rem 0 0.5rem;
  position: relative;
  width: 1rem;
}
.header__content .lang {
  height: 1rem;
  position: relative;
  width: 1rem;
}
.header__content input {
  cursor: pointer;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}
.header__content .logo {
  height: 100%;
  width: 2rem;
}
.header__content .logo__text {
  display: none;
  margin-left: 1rem;
}
.header__content .logo path {
  fill: rgb(255, 255, 255);
  fill: var(--colorContent);
}

#loader {
  -webkit-animation: fadeOut 500ms forwards 3.5s;
          animation: fadeOut 500ms forwards 3.5s;
  background: rgb(255, 255, 255);
  background: var(--colorContent);
  opacity: 1;
  visibility: visible;
  z-index: 2;
}
#loader path:nth-child(1) {
  -webkit-animation: loaderStroke 3s forwards ease-in-out;
          animation: loaderStroke 3s forwards ease-in-out;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}
#loader path:nth-child(2) {
  -webkit-animation: loaderStroke 2s forwards ease-in-out 0.3s;
          animation: loaderStroke 2s forwards ease-in-out 0.3s;
  stroke-dasharray: 581.5840454102;
  stroke-dashoffset: 581.5840454102;
}
#loader path:nth-child(3) {
  -webkit-animation: loaderStroke 2s forwards ease-in-out 0.6s;
          animation: loaderStroke 2s forwards ease-in-out 0.6s;
  stroke-dasharray: 715.9073486328;
  stroke-dashoffset: 715.9073486328;
}
#loader svg {
  -webkit-animation: loaderScale 1s forwards ease-in-out 3s;
          animation: loaderScale 1s forwards ease-in-out 3s;
}

.pyramid__wrapper {
  bottom: 3%;
  position: absolute;
  right: 5%;
}
[data-section] .pyramid__wrapper {
  display: none;
}
[data-section=skills] .pyramid__wrapper {
  display: block;
}

.pyramid {
  height: 5rem;
  position: relative;
  -webkit-transform: rotateY(-45deg) rotateZ(-30deg);
          transform: rotateY(-45deg) rotateZ(-30deg);
  -webkit-transform: var(--pyramidTransform);
          transform: var(--pyramidTransform);
  -webkit-transform-style: preserve-3d;
          transform-style: preserve-3d;
  -webkit-transition: -webkit-transform 250ms ease-in-out;
  transition: -webkit-transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out, -webkit-transform 250ms ease-in-out;
  width: 5rem;
}
.pyramid .pyramid__base {
  background: rgb(37, 41, 50);
  background: var(--colorBgPrimary);
  border: 0.15rem solid rgb(255, 255, 255);
  border: 0.15rem solid var(--colorContent);
  height: 100%;
  position: absolute;
  -webkit-transform: rotateX(90deg) translateZ(-1.8rem);
          transform: rotateX(90deg) translateZ(-1.8rem);
  width: 100%;
}
.pyramid .pyramid__side {
  border: 2.5rem solid transparent;
  border-bottom: 5rem solid rgb(255, 255, 255);
  border-bottom: 5rem solid var(--colorContent);
  border-top: 0;
  position: absolute;
}
.pyramid .pyramid__side::before {
  border: 2.4rem solid transparent;
  border-bottom: 4.8rem solid rgb(37, 41, 50);
  border-bottom: 4.8rem solid var(--colorBgPrimary);
  content: "";
  left: -2.4rem;
  position: absolute;
  top: -2.25rem;
}
.pyramid .pyramid__side--back {
  -webkit-transform: rotateX(-30deg);
          transform: rotateX(-30deg);
  -webkit-transform-origin: 2.5rem 0;
          transform-origin: 2.5rem 0;
}
.pyramid .pyramid__side--front {
  -webkit-transform: rotateX(30deg);
          transform: rotateX(30deg);
  -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
}
.pyramid .pyramid__side--left {
  -webkit-transform: rotateZ(30deg) rotateY(90deg);
          transform: rotateZ(30deg) rotateY(90deg);
  -webkit-transform-origin: 2.5rem 0;
          transform-origin: 2.5rem 0;
}
.pyramid .pyramid__side--right {
  -webkit-transform: rotateZ(-30deg) rotateY(90deg);
          transform: rotateZ(-30deg) rotateY(90deg);
  -webkit-transform-origin: 2.5rem 0;
          transform-origin: 2.5rem 0;
}

#shapes {
  opacity: 1;
  text-align: center;
  visibility: visible;
}
#shapes .title {
  font-size: 2.1875rem;
  max-width: 75%;
}
[data-section] #shapes .title {
  display: none;
}
#shapes .menu {
  z-index: 1;
}
[data-section] #shapes .menu {
  display: none;
}
#shapes .menu button {
  cursor: help;
  font-size: 0.75rem;
  margin: 0 1rem;
}
#shapes .menu ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

#skills {
  -webkit-box-pack: initial;
      -ms-flex-pack: initial;
          justify-content: initial;
  padding: 6rem 0;
}
#skills__content {
  max-height: 81.5%;
  overflow-y: auto;
  width: 85%;
}
#skills .skill {
  border-bottom: 0.15rem solid rgb(255, 255, 255);
  border-bottom: 0.15rem solid var(--colorContent);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 0.75rem 0;
}
#skills a {
  display: block;
}
#skills img {
  margin: 0.5rem 0;
  max-height: 2.75rem;
  max-width: 2.75rem;
}
#skills .icon {
  display: inline-block;
  margin: 0 0.5rem;
  text-align: center;
}
#skills .project {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.sphere {
  background: linear-gradient(0.45turn, rgb(255, 255, 255), transparent);
  background: linear-gradient(0.45turn, var(--colorContent), transparent);
  border-radius: 50%;
  -webkit-box-shadow: inset -0.5rem -0.5rem 2rem rgba(0, 0, 0, 0.2);
          box-shadow: inset -0.5rem -0.5rem 2rem rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset -0.5rem -0.5rem 2rem var(--colorShadow);
          box-shadow: inset -0.5rem -0.5rem 2rem var(--colorShadow);
  height: calc(6rem * 0.85);
  height: calc(var(--shapeSize) * 0.85);
  position: absolute;
  right: 5%;
  top: 15%;
  -webkit-transition: -webkit-transform 250ms ease-in-out;
  transition: -webkit-transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out;
  transition: transform 250ms ease-in-out, -webkit-transform 250ms ease-in-out;
  width: calc(6rem * 0.85);
  width: calc(var(--shapeSize) * 0.85);
}
[data-section] .sphere {
  display: none;
}
[data-section=contact] .sphere {
  display: block;
}

.title {
  font-family: "Gugi", cursive;
  margin: 0.75rem 0;
}`, "",{"version":3,"sources":["webpack://./src/scss/abstracts/_keyframes.scss","webpack://./src/scss/main.scss","webpack://./src/scss/abstracts/_media.scss","webpack://./src/scss/base/_base.scss","webpack://./src/scss/abstracts/_tokens.scss","webpack://./src/scss/base/_reset.scss","webpack://./src/scss/components/_about.scss","webpack://./src/scss/components/_back.scss","webpack://./src/scss/components/_colorPicker.scss","webpack://./src/scss/components/_contact.scss","webpack://./src/scss/components/_cube.scss","webpack://./src/scss/components/_cursor.scss","webpack://./src/scss/components/_header.scss","webpack://./src/scss/components/_loader.scss","webpack://./src/scss/components/_pyramid.scss","webpack://./src/scss/components/_shapes.scss","webpack://./src/scss/components/_skills.scss","webpack://./src/scss/components/_sphere.scss","webpack://./src/scss/components/_title.scss"],"names":[],"mappings":"AAGA;EACE;IACE,UAAA;IACA,kBAAA;ECAF;EDGA;IACE,UAAA;IACA,mBAAA;ECDF;AACF;ADRA;EACE;IACE,UAAA;IACA,kBAAA;ECAF;EDGA;IACE,UAAA;IACA,mBAAA;ECDF;AACF;ADIA;EACE;IACE,UAAA;IACA,mBAAA;ECFF;EDIA;IACE,UAAA;IACA,kBAAA;ECFF;AACF;ADNA;EACE;IACE,UAAA;IACA,mBAAA;ECFF;EDIA;IACE,UAAA;IACA,kBAAA;ECFF;AACF;ADMA;EACE;IAEE,cAAA;ECLF;AACF;ADCA;EACE;IAEE,cAAA;ECLF;AACF;ADQA;EACE;IACE,oCAAA;YAAA,4BAAA;ECNF;EDQA;IACE,gCAAA;YAAA,wBAAA;ECNF;AACF;ADAA;EACE;IACE,oCAAA;YAAA,4BAAA;ECNF;EDQA;IACE,gCAAA;YAAA,wBAAA;ECNF;AACF;ADSA;EACE;IACE,gCAAA;YAAA,wBAAA;ECPF;EDSA;IACE,oCAAA;YAAA,4BAAA;ECPF;AACF;ADCA;EACE;IACE,gCAAA;YAAA,wBAAA;ECPF;EDSA;IACE,oCAAA;YAAA,4BAAA;ECPF;AACF;ADUA;EACE;IACE,4BAAA;YAAA,oBAAA;ECRF;EDUA;IACE,iCAAA;YAAA,yBAAA;ECRF;AACF;ADEA;EACE;IACE,4BAAA;YAAA,oBAAA;ECRF;EDUA;IACE,iCAAA;YAAA,yBAAA;ECRF;AACF;ADWA;EACE;IACE,oBAAA;ECTF;AACF;ADMA;EACE;IACE,oBAAA;ECTF;AACF;ACpDA;EACE;IACE,+BAAA;EDsDF;ECnDA;IACE,yBAAA;EDqDF;ECnDE;IACE,8DAAA;YAAA,sDAAA;IACA,yBAAA;EDqDJ;ECjDA;IACE,oBAAA;IACA,6BAAA;YAAA,qBAAA;EDmDF;EChDA;IACE,yBAAA;QAAA,sBAAA;YAAA,mBAAA;IACA,yCAAA;IAAA,wCAAA;QAAA,kCAAA;YAAA,8BAAA;EDkDF;AACF;AC/CA;EACE;IACE,6BAAA;EDiDF;EC9CA;IACE,oBAAA;EDgDF;EC7CA;IACE,yBAAA;ED+CF;EC5CA;IACE,8BAAA;ED8CF;AACF;AC3CA;EACE;IACE,yCAAA;IACA,0CAAA;ED6CF;EC3CE;IACE,2BAAA;ED6CJ;ECzCA;IACE,sBAAA;IACA,mBAAA;ED2CF;ECxCA;IACE,sBAAA;IACA,oBAAA;ED0CF;ECvCA;IACE,mCAAA;QAAA,gCAAA;YAAA,kCAAA;IACA,mCAAA;EDyCF;ECvCE;IACE,qBAAA;EDyCJ;ECvCI;IACE,yBAAA;EDyCN;ECpCA;IACE,qBAAA;IACA,qBAAA;EDsCF;AACF;ACnCA;EACE;IACE,yBAAA;IACA,8BAAA;IAAA,0CAAA;EDqCF;EClCA;IACE,sBAAA;IACA,oBAAA;EDoCF;ECjCA;IACE,yBAAA;EDmCF;EChCA;IACE,sBAAA;IACA,qBAAA;IACA,6BAAA;YAAA,qBAAA;EDkCF;EC/BA;IACE,+BAAA;EDiCF;EC9BA;IACE,qBAAA;EDgCF;EC9BE;IACE,2BAAA;EDgCJ;EC5BA;IACE,oCAAA;IAAA,gDAAA;IACA,qBAAA;IACA,mBAAA;IACA,mCAAA;IAAA,+CAAA;ED8BF;AACF;AC3BA;EACE;;IAEE,qBAAA;ED6BF;AACF;ACzBA;EACE;IACE,sBAAA;IACA,6BAAA;YAAA,qBAAA;ED2BF;ECxBA;IACE,sBAAA;ED0BF;ECvBA;IACE,uBAAA;IACA,mBAAA;EDyBF;AACF;ACtBA;EACE;IACE,sBAAA;EDwBF;ECrBA;IACE,sBAAA;EDuBF;AACF;ACpBA;EACE;IACE,2BAAA;EDsBF;ECnBA;IACE,sBAAA;IACA,oBAAA;EDqBF;EClBA;IACE,sBAAA;IACA,qBAAA;IACA,wCAAA;YAAA,gCAAA;EDoBF;ECjBA;IACE,+BAAA;EDmBF;EChBA;IACE,oCAAA;IAAA,gDAAA;IACA,qBAAA;IACA,mCAAA;IAAA,+CAAA;EDkBF;AACF;AExMA;EACE,iCAAA;EACA,4CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,0BAAA;EAEA,mDAAA;EAEA,iBAAA;EAEA,UAAA;AFsMF;;AEnMA;EACE,2BCeO;EDfP,iCCeO;EDdP,yBCeU;EDfV,0BCeU;EDdV,iCCXoB;EDYpB,mBCNW;EDQX,iBAAA;EACA,gBAAA;EAAA,qBAAA;EACA,gBAAA;AFqMF;;AElMA;EACE,yBCKU;EDLV,0BCKU;AHgMZ;;AElMA;EACE,gBAAA;EACA,YAAA;EACA,yBCDU;EDCV,0BCDU;EDEV,eAAA;EACA,iCC5BoB;AHiOtB;;AElMA;EACE,eAAA;EACA,WAAA;EACA,UCpBa;AHyNf;;AElMA;EAEE,aAAA;EACA,YAAA;EAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;AFoMF;;AEjMA;EACE,gBClBe;AHsNjB;;AEhMA;EACE,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,YAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AFmMF;AEjME;EACE,eCqBoB;AH8KxB;AEhME;EACE,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;AFkMJ;;AE9LA;EACE,gBAAA;AFiMF;;AE9LA;EACE,aCGe;AH8LjB;AE/LE;EACE,oCCFU;EDEV,mCCFU;EDGV,qBCFoB;AHmMxB;;AI3RA;EACE,8BAAA;UAAA,sBAAA;EACA,SAAA;EACA,UAAA;AJ8RF;;AK/RA;EACE,0BAAA;MAAA,uBAAA;UAAA,oBAAA;EACA,aAAA;EACA,4BFsByB;EErBzB,oBFsBa;EErBb,mBAAA;ALkSF;AKhSE;EACE,eFmBoB;EElBpB,gBAAA;ALkSJ;;AM3SA;EACE,gBH4BiB;AHkRnB;;AO/SA;EACE,qBJoCwB;EInCxB,aAAA;EACA,YJmCkB;EIlClB,gBAAA;EACA,kBAAA;EACA,sCJYgB;EIZhB,8BJYgB;EIXhB,QAAA;APkTF;AOhTE;EACE,YAAA;EACA,WAAA;APkTJ;AO/SE;EACE,oCJyBmB;EIzBnB,mCJyBmB;EIxBnB,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,wCAAA;UAAA,gCAAA;EACA,WJoBsB;AH6R1B;;AQrUE;EACE,cAAA;EACA,cLwCmB;AHgSvB;;AS3UA;EACE,WNgDkB;EM/ClB,ONgDgB;EM/ChB,2BNgDuB;UMhDvB,mBNgDuB;EM/CvB,qCNgD6B;UMhD7B,6BNgD6B;EM/C7B,kBAAA;AT8UF;AS3UE;EACE,aAAA;AT6UJ;AS3UE;EACE,cAAA;AT6UJ;;ASzUA;EACE,YNDU;EMCV,wBNDU;EMEV,kBAAA;EACA,kCN0Bc;UM1Bd,0BN0Bc;EMzBd,oCAAA;UAAA,4BAAA;EACA,WNLU;EMKV,uBNLU;AHiVZ;AS1UE;EACE,wCNnBY;EMmBZ,yCNnBY;EMoBZ,YAAA;EACA,kBAAA;EACA,uDNRwB;EMQxB,+CNRwB;EMQxB,uCNRwB;EMQxB,4ENRwB;EMSxB,WAAA;AT4UJ;AS1UI;EACE,QAAA;EACA,2DAAA;UAAA,mDAAA;EAAA,4FAAA;UAAA,oFAAA;AT4UN;ASvUI;EACE,SAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,kFAAA;UAAA,0EAAA;ATyUN;ASrUI;EACE,QAAA;EACA,oDAAA;UAAA,4CAAA;EAAA,qFAAA;UAAA,6EAAA;ATuUN;ASlUI;EACE,UAAA;EACA,QAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,kFAAA;UAAA,0EAAA;AToUN;AShUI;EACE,SAAA;EACA,QAAA;EACA,kDAAA;UAAA,0CAAA;EAAA,uEAAA;UAAA,+DAAA;ATkUN;AS/TI;EACE,kDAAA;UAAA,0CAAA;EAAA,uEAAA;UAAA,+DAAA;ATiUN;;AUjYA;EACE,wCPIc;EOJd,yCPIc;EOHd,kBAAA;EAEA,aAAA;EACA,YPkDW;EOjDX,oBAAA;EACA,eAAA;EACA,wCAAA;UAAA,gCAAA;EAEA,mCAAA;UAAA,2BAAA;EAEA,sCPMgB;EONhB,8BPMgB;EOLhB,WP0CW;EOzCX,UPQa;AHyXf;AU/XE;EACE,8BP2Ca;EO3Cb,+BP2Ca;EO1Cb,kBAAA;EACA,WAAA;EACA,cPyCe;EOxCf,SAAA;EACA,kBAAA;EACA,QAAA;EACA,wCAAA;UAAA,gCAAA;EACA,aPoCe;AH6VnB;AU9XE;EACE,8BP6Ba;EO7Bb,+BP6Ba;EO5Bb,0BAAA;EACA,6BP4BoB;UO5BpB,qBP4BoB;AHoWxB;AU9XI;EACE,aAAA;AVgYN;;AWlaA;EACE,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,iCRoEoB;AHiWtB;AWnaE;EAEE,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;AXoaJ;AWjaE;EACE,eRCS;AHkab;AWjaI;EACE,YR2DW;AHwWjB;AW/ZE;EACE,iFR6CY;EQ7CZ,iFR6CY;EQ5CZ,kBAAA;EACA,aAAA;EACA,YRkDqB;EQjDrB,yBR8CgB;EQ7ChB,kBAAA;EACA,WR+CqB;AHkXzB;AW9ZE;EACE,YR2CqB;EQ1CrB,kBAAA;EACA,WRyCqB;AHuXzB;AW5ZE;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AX8ZJ;AW3ZE;EACE,YAAA;EACA,WR4Ba;AHiYjB;AW1ZI;EACE,aAAA;EACA,iBRyBqB;AHmY3B;AWzZI;EACE,wBRoBe;EQpBf,yBRoBe;AHuYrB;;AYjdA;EACE,8CAAA;UAAA,sCAAA;EACA,8BT2ES;ES3ET,+BT2ES;ES1ET,UAAA;EACA,mBAAA;EACA,UTiBa;AHmcf;AYldE;EACE,uDAAA;UAAA,+CAAA;EACA,sBAAA;EACA,uBAAA;AZodJ;AYjdE;EACE,4DAAA;UAAA,oDAAA;EACA,gCAAA;EACA,iCAAA;AZmdJ;AYhdE;EACE,4DAAA;UAAA,oDAAA;EACA,gCAAA;EACA,iCAAA;AZkdJ;AY/cE;EACE,yDAAA;UAAA,iDAAA;AZidJ;;AaveA;EACE,UV6EqB;EU5ErB,kBAAA;EACA,SV4EoB;AH8ZtB;AaveE;EACE,aAAA;AbyeJ;AaveE;EACE,cAAA;AbyeJ;;AareA;EACE,YAlBY;EAmBZ,kBAAA;EACA,kDV2DiB;UU3DjB,0CV2DiB;EU3DjB,0CV2DiB;UU3DjB,kCV2DiB;EU1DjB,oCAAA;UAAA,4BAAA;EACA,uDVJ0B;EUI1B,+CVJ0B;EUI1B,uCVJ0B;EUI1B,4EVJ0B;EUK1B,WAvBY;Ab+fd;AateE;EACE,2BAAA;EAAA,iCAAA;EACA,wCAAA;EAAA,yCAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;UAAA,6CAAA;EACA,WAAA;AbweJ;AareE;EACE,gCAAA;EACA,4CAAA;EAAA,6CAAA;EACA,aAAA;EACA,kBAAA;AbueJ;AareI;EACE,gCAAA;EACA,2CAAA;EAAA,iDAAA;EAEA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AbseN;AaneI;EACE,kCAAA;UAAA,0BAAA;EACA,kCAAA;UAAA,0BAAA;AbqeN;AaleI;EACE,iCAAA;UAAA,yBAAA;EACA,6BAAA;UAAA,qBAAA;AboeN;AajeI;EACE,gDAAA;UAAA,wCAAA;EACA,kCAAA;UAAA,0BAAA;AbmeN;AaheI;EACE,iDAAA;UAAA,yCAAA;EACA,kCAAA;UAAA,0BAAA;AbkeN;;ActiBA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AdyiBF;AcviBE;EACE,oBXKS;EWJT,cXyFkB;AHgdtB;ActiBI;EACE,aAAA;AdwiBN;AcpiBE;EACE,UXKW;AHiiBf;AcniBI;EACE,aAAA;AdqiBN;AcliBI;EACE,YAAA;EACA,kBXXO;EWYP,cXoEmB;AHgezB;AcjiBI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;AdmiBN;;AejkBA;EACE,yBAAA;MAAA,sBAAA;UAAA,wBAAA;EACA,eZmGc;AHiehB;AelkBE;EACE,iBZ+Fc;EY9Fd,gBAAA;EACA,UZ+FU;AHqed;AejkBE;EACE,+CZNY;EYMZ,gDZNY;EYOZ,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,kBZoFW;AH+ef;AehkBE;EACE,cAAA;AfkkBJ;Ae/jBE;EACE,gBZiFc;EYhFd,mBZiFY;EYhFZ,kBZgFY;AHifhB;Ae9jBE;EACE,qBAAA;EACA,gBZyEe;EYxEf,kBAAA;AfgkBJ;Ae7jBE;EACE,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,SZqEe;EYpEf,gBZqEqB;AH0fzB;;AgBrmBA;EACE,sEb4GS;Ea5GT,uEb4GS;Ea3GT,kBAAA;EACA,iEb2GgB;Ua3GhB,yDb2GgB;Ea3GhB,iEb2GgB;Ua3GhB,yDb2GgB;Ea1GhB,yBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,SbyGY;EaxGZ,QbyGU;EaxGV,uDbW0B;EaX1B,+CbW0B;EaX1B,uCbW0B;EaX1B,4EbW0B;EaV1B,wBAAA;EAAA,oCAAA;AhBwmBF;AgBrmBE;EACE,aAAA;AhBumBJ;AgBrmBE;EACE,cAAA;AhBumBJ;;AiBvnBA;EACE,4BdOe;EcNf,iBdkHY;AHwgBd","sourcesContent":["@use \"./tokens\";\n\n//** Global keyframes\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n//** Contestual keyframes\n@keyframes colorPickerWidth {\n  100% {\n    // Same as canvas (200px)\n    width: 12.5rem;\n  }\n}\n\n@keyframes contentSlideDown {\n  0% {\n    transform: translateY(tokens.$sectionContentAnimationSlideY);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@keyframes contentSlideUp {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(tokens.$sectionContentAnimationSlideY);\n  }\n}\n\n@keyframes loaderScale {\n  50% {\n    transform: scale(1%);\n  }\n  100% {\n    transform: scale(100000%);\n  }\n}\n\n@keyframes loaderStroke {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Comfortaa&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Gugi&display=swap\");\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    visibility: hidden;\n  }\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n@keyframes colorPickerWidth {\n  100% {\n    width: 12.5rem;\n  }\n}\n@keyframes contentSlideDown {\n  0% {\n    transform: translateY(-2rem);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@keyframes contentSlideUp {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-2rem);\n  }\n}\n@keyframes loaderScale {\n  50% {\n    transform: scale(1%);\n  }\n  100% {\n    transform: scale(100000%);\n  }\n}\n@keyframes loaderStroke {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n@media screen and (min-width: 320px) {\n  #about {\n    padding: 6rem 2.5rem !important;\n  }\n  .color {\n    display: block !important;\n  }\n  .color-picker {\n    animation: colorPickerWidth 150ms forwards ease-in-out;\n    display: block !important;\n  }\n  .cube__wrapper {\n    left: 10% !important;\n    transform: scale(1.1);\n  }\n  .skill {\n    align-items: center;\n    flex-direction: row !important;\n  }\n}\n@media screen and (min-width: 480px) {\n  #about {\n    padding: 5rem 4rem !important;\n  }\n  .cube__wrapper {\n    left: 15% !important;\n  }\n  .logo__text {\n    display: block !important;\n  }\n  .menu button {\n    font-size: 0.875rem !important;\n  }\n}\n@media screen and (min-width: 541px) {\n  #about {\n    grid-template-columns: 1fr 2fr !important;\n    padding: 3.25rem 4rem 4rem 2rem !important;\n  }\n  #about__content {\n    max-height: 100% !important;\n  }\n  .cube__wrapper {\n    bottom: 45% !important;\n    left: 5% !important;\n  }\n  .pyramid__wrapper {\n    bottom: 20% !important;\n    right: 5% !important;\n  }\n  #skills {\n    justify-content: center !important;\n    padding: 2rem 0 2.5rem 0 !important;\n  }\n  #skills__content {\n    width: 60% !important;\n  }\n  #skills__content .icon {\n    margin: 0 1rem !important;\n  }\n  .sphere {\n    right: 25% !important;\n    top: 17.5% !important;\n  }\n}\n@media screen and (min-width: 1024px) {\n  #about__content {\n    padding: 12.5% !important;\n    min-height: calc(100vh - var(--shapeSize));\n  }\n  .cube__wrapper {\n    bottom: 30% !important;\n    left: 10% !important;\n  }\n  .email {\n    font-size: 4vw !important;\n  }\n  .pyramid__wrapper {\n    bottom: 15% !important;\n    right: 15% !important;\n    transform: scale(1.5);\n  }\n  #shapes .title {\n    font-size: 2.8125rem !important;\n  }\n  #skills__content {\n    width: 50% !important;\n  }\n  #skills__content .icon {\n    margin: 0 1.5rem !important;\n  }\n  .sphere {\n    height: calc(var(--shapeSize) * 1.15) !important;\n    right: 20% !important;\n    top: 15% !important;\n    width: calc(var(--shapeSize) * 1.15) !important;\n  }\n}\n@media screen and (min-width: 1441px) {\n  #about__content,\n  #skills {\n    padding: 0 !important;\n  }\n}\n@media screen and (max-height: 320px) {\n  .cube__wrapper {\n    bottom: 40% !important;\n    transform: scale(0.9);\n  }\n  .pyramid__wrapper {\n    bottom: 10% !important;\n  }\n  .sphere {\n    right: 12.5% !important;\n    top: 20% !important;\n  }\n}\n@media screen and (min-height: 576px) {\n  .cube__wrapper {\n    bottom: 25% !important;\n  }\n  .pyramid__wrapper {\n    bottom: 10% !important;\n  }\n}\n@media screen and (min-height: 1024px) {\n  #about {\n    padding: 25% 10% !important;\n  }\n  .cube__wrapper {\n    bottom: 35% !important;\n    left: 15% !important;\n  }\n  .pyramid__wrapper {\n    bottom: 15% !important;\n    right: 20% !important;\n    transform: scale(1.5) !important;\n  }\n  #shapes .title {\n    font-size: 2.8125rem !important;\n  }\n  .sphere {\n    height: calc(var(--shapeSize) * 1.15) !important;\n    top: 22.5% !important;\n    width: calc(var(--shapeSize) * 1.15) !important;\n  }\n}\n:root {\n  --colorBgPrimary: rgb(37, 41, 50);\n  --colorBgSecondary: rgba(117, 117, 162, 0.6);\n  --colorContent: rgb(255, 255, 255);\n  --colorShadow: rgba(0, 0, 0, 0.2);\n  --cubeSideTranslateZ: 0rem;\n  --pyramidTransform: rotateY(-45deg) rotateZ(-30deg);\n  --shapeSize: 6rem;\n  --vh: 100%;\n}\n\nbody {\n  background: var(--colorBgPrimary);\n  color: var(--colorContent);\n  font-family: \"Comfortaa\", cursive;\n  font-size: 0.875rem;\n  min-height: 100vh;\n  min-height: var(--vh);\n  overflow: hidden;\n}\n\na {\n  color: var(--colorContent);\n}\n\nbutton {\n  background: none;\n  border: none;\n  color: var(--colorContent);\n  cursor: pointer;\n  font-family: \"Comfortaa\", cursive;\n}\n\nheader {\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n}\n\nmain {\n  height: 100vh;\n  height: var(--vh);\n  overflow: hidden;\n  position: relative;\n}\n\np {\n  line-height: 1.4;\n}\n\nsection {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n  width: 100%;\n}\nsection > div {\n  padding: 0 1rem;\n}\nsection .section--top {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\nul {\n  list-style: none;\n}\n\n::-webkit-scrollbar {\n  width: 0.2rem;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--colorBgSecondary);\n  border-radius: 0.5rem;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n#about {\n  align-items: initial;\n  display: grid;\n  grid-template-columns: 0 1fr;\n  padding: 4.5rem 1rem;\n  text-align: justify;\n}\n#about__content {\n  max-height: 60%;\n  overflow-y: auto;\n}\n\n.back__btn {\n  margin-top: 2rem;\n}\n\n.color-picker {\n  border-radius: 0.3rem;\n  display: none;\n  height: 2rem;\n  overflow: hidden;\n  position: relative;\n  transition: all 150ms ease-out;\n  width: 0;\n}\n.color-picker canvas {\n  height: 100%;\n  width: 100%;\n}\n.color-picker .pointer {\n  background: var(--colorBgSecondary);\n  height: 100%;\n  left: 0.5rem;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 1rem;\n}\n\n#contact .email {\n  display: block;\n  font-size: 5vw;\n}\n\n.cube__wrapper {\n  bottom: 15%;\n  left: 0;\n  perspective: 100rem;\n  perspective-origin: 50% -250%;\n  position: absolute;\n}\n[data-section] .cube__wrapper {\n  display: none;\n}\n[data-section=about] .cube__wrapper {\n  display: block;\n}\n\n.cube {\n  height: var(--shapeSize);\n  position: relative;\n  transform: rotateY(-30deg);\n  transform-style: preserve-3d;\n  width: var(--shapeSize);\n}\n.cube .cube__side {\n  border: 0.15rem solid var(--colorContent);\n  height: 100%;\n  position: absolute;\n  transition: transform 250ms ease-in-out;\n  width: 100%;\n}\n.cube .cube__side--back {\n  top: 50%;\n  transform: translateZ(calc(-1 * (var(--shapeSize) / 2 + var(--cubeSideTranslateZ))));\n}\n.cube .cube__side--bottom {\n  top: 100%;\n  transform: rotateX(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));\n}\n.cube .cube__side--front {\n  top: 50%;\n  transform: translateZ(calc(var(--shapeSize) / 2 + var(--cubeSideTranslateZ)));\n}\n.cube .cube__side--left {\n  right: 50%;\n  top: 50%;\n  transform: rotateY(90deg) translateZ(calc(-1 * var(--cubeSideTranslateZ)));\n}\n.cube .cube__side--right {\n  left: 50%;\n  top: 50%;\n  transform: rotateY(90deg) translateZ(var(--cubeSideTranslateZ));\n}\n.cube .cube__side--top {\n  transform: rotateX(90deg) translateZ(var(--cubeSideTranslateZ));\n}\n\n.cursor {\n  border: 0.15rem solid var(--colorContent);\n  border-radius: 50%;\n  display: none;\n  height: 2rem;\n  pointer-events: none;\n  position: fixed;\n  transform: translate(-50%, -50%);\n  transform-origin: 150% 150%;\n  transition: all 150ms ease-out;\n  width: 2rem;\n  z-index: 2;\n}\n.cursor::before {\n  background: var(--colorContent);\n  border-radius: 50%;\n  content: \"\";\n  height: 0.3rem;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 0.3rem;\n}\n.cursor--active {\n  background: var(--colorContent);\n  mix-blend-mode: soft-light;\n  transform: scale(1.5);\n}\n.cursor--active::before {\n  display: none;\n}\n\n.header__content {\n  justify-content: space-between;\n  margin: 1.75rem 1.75rem 0 1.75rem;\n}\n.header__content, .header__content > div {\n  align-items: center;\n  display: flex;\n}\n.header__content--left {\n  font-size: 1rem;\n}\n.header__content--left a {\n  height: 2rem;\n}\n.header__content .color {\n  background: linear-gradient(-45deg, var(--colorBgSecondary), var(--colorContent));\n  border-radius: 50%;\n  display: none;\n  height: 1rem;\n  margin: 0 1.5rem 0 0.5rem;\n  position: relative;\n  width: 1rem;\n}\n.header__content .lang {\n  height: 1rem;\n  position: relative;\n  width: 1rem;\n}\n.header__content input {\n  cursor: pointer;\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n}\n.header__content .logo {\n  height: 100%;\n  width: 2rem;\n}\n.header__content .logo__text {\n  display: none;\n  margin-left: 1rem;\n}\n.header__content .logo path {\n  fill: var(--colorContent);\n}\n\n#loader {\n  animation: fadeOut 500ms forwards 3.5s;\n  background: var(--colorContent);\n  opacity: 1;\n  visibility: visible;\n  z-index: 2;\n}\n#loader path:nth-child(1) {\n  animation: loaderStroke 3s forwards ease-in-out;\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n}\n#loader path:nth-child(2) {\n  animation: loaderStroke 2s forwards ease-in-out 0.3s;\n  stroke-dasharray: 581.5840454102;\n  stroke-dashoffset: 581.5840454102;\n}\n#loader path:nth-child(3) {\n  animation: loaderStroke 2s forwards ease-in-out 0.6s;\n  stroke-dasharray: 715.9073486328;\n  stroke-dashoffset: 715.9073486328;\n}\n#loader svg {\n  animation: loaderScale 1s forwards ease-in-out 3s;\n}\n\n.pyramid__wrapper {\n  bottom: 3%;\n  position: absolute;\n  right: 5%;\n}\n[data-section] .pyramid__wrapper {\n  display: none;\n}\n[data-section=skills] .pyramid__wrapper {\n  display: block;\n}\n\n.pyramid {\n  height: 5rem;\n  position: relative;\n  transform: var(--pyramidTransform);\n  transform-style: preserve-3d;\n  transition: transform 250ms ease-in-out;\n  width: 5rem;\n}\n.pyramid .pyramid__base {\n  background: var(--colorBgPrimary);\n  border: 0.15rem solid var(--colorContent);\n  height: 100%;\n  position: absolute;\n  transform: rotateX(90deg) translateZ(-1.8rem);\n  width: 100%;\n}\n.pyramid .pyramid__side {\n  border: 2.5rem solid transparent;\n  border-bottom: 5rem solid var(--colorContent);\n  border-top: 0;\n  position: absolute;\n}\n.pyramid .pyramid__side::before {\n  border: 2.4rem solid transparent;\n  border-bottom: 4.8rem solid var(--colorBgPrimary);\n  content: \"\";\n  left: -2.4rem;\n  position: absolute;\n  top: -2.25rem;\n}\n.pyramid .pyramid__side--back {\n  transform: rotateX(-30deg);\n  transform-origin: 2.5rem 0;\n}\n.pyramid .pyramid__side--front {\n  transform: rotateX(30deg);\n  transform-origin: 0 0;\n}\n.pyramid .pyramid__side--left {\n  transform: rotateZ(30deg) rotateY(90deg);\n  transform-origin: 2.5rem 0;\n}\n.pyramid .pyramid__side--right {\n  transform: rotateZ(-30deg) rotateY(90deg);\n  transform-origin: 2.5rem 0;\n}\n\n#shapes {\n  opacity: 1;\n  text-align: center;\n  visibility: visible;\n}\n#shapes .title {\n  font-size: 2.1875rem;\n  max-width: 75%;\n}\n[data-section] #shapes .title {\n  display: none;\n}\n#shapes .menu {\n  z-index: 1;\n}\n[data-section] #shapes .menu {\n  display: none;\n}\n#shapes .menu button {\n  cursor: help;\n  font-size: 0.75rem;\n  margin: 0 1rem;\n}\n#shapes .menu ul {\n  display: flex;\n}\n\n#skills {\n  justify-content: initial;\n  padding: 6rem 0;\n}\n#skills__content {\n  max-height: 81.5%;\n  overflow-y: auto;\n  width: 85%;\n}\n#skills .skill {\n  border-bottom: 0.15rem solid var(--colorContent);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n}\n#skills a {\n  display: block;\n}\n#skills img {\n  margin: 0.5rem 0;\n  max-height: 2.75rem;\n  max-width: 2.75rem;\n}\n#skills .icon {\n  display: inline-block;\n  margin: 0 0.5rem;\n  text-align: center;\n}\n#skills .project {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.sphere {\n  background: linear-gradient(0.45turn, var(--colorContent), transparent);\n  border-radius: 50%;\n  box-shadow: inset -0.5rem -0.5rem 2rem var(--colorShadow);\n  height: calc(var(--shapeSize) * 0.85);\n  position: absolute;\n  right: 5%;\n  top: 15%;\n  transition: transform 250ms ease-in-out;\n  width: calc(var(--shapeSize) * 0.85);\n}\n[data-section] .sphere {\n  display: none;\n}\n[data-section=contact] .sphere {\n  display: block;\n}\n\n.title {\n  font-family: \"Gugi\", cursive;\n  margin: 0.75rem 0;\n}","@use \"./tokens\";\n\n//** Width\n@media screen and (min-width: 320px) {\n  #about {\n    padding: 6rem 2.5rem !important;\n  }\n\n  .color {\n    display: block !important;\n\n    &-picker {\n      animation: colorPickerWidth 150ms forwards ease-in-out;\n      display: block !important;\n    }\n  }\n\n  .cube__wrapper {\n    left: 10% !important;\n    transform: scale(1.1);\n  }\n\n  .skill {\n    align-items: center;\n    flex-direction: row !important;\n  }\n}\n\n@media screen and (min-width: 480px) {\n  #about {\n    padding: 5rem 4rem !important;\n  }\n\n  .cube__wrapper {\n    left: 15% !important;\n  }\n\n  .logo__text {\n    display: block !important;\n  }\n\n  .menu button {\n    font-size: tokens.$fontSizeT4 !important;\n  }\n}\n\n@media screen and (min-width: 541px) {\n  #about {\n    grid-template-columns: 1fr 2fr !important;\n    padding: 3.25rem 4rem 4rem 2rem !important;\n\n    &__content {\n      max-height: 100% !important;\n    }\n  }\n\n  .cube__wrapper {\n    bottom: 45% !important;\n    left: 5% !important;\n  }\n\n  .pyramid__wrapper {\n    bottom: 20% !important;\n    right: 5% !important;\n  }\n\n  #skills {\n    justify-content: center !important;\n    padding: 2rem 0 2.5rem 0 !important;\n\n    &__content {\n      width: 60% !important;\n\n      .icon {\n        margin: 0 1rem !important;\n      }\n    }\n  }\n\n  .sphere {\n    right: 25% !important;\n    top: 17.5% !important;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  #about__content {\n    padding: 12.5% !important;\n    min-height: calc(100vh - #{tokens.$shapeSize});\n  }\n\n  .cube__wrapper {\n    bottom: 30% !important;\n    left: 10% !important;\n  }\n\n  .email {\n    font-size: 4vw !important;\n  }\n\n  .pyramid__wrapper {\n    bottom: 15% !important;\n    right: 15% !important;\n    transform: scale(1.5);\n  }\n\n  #shapes .title {\n    font-size: tokens.$fontSizeH3 !important;\n  }\n\n  #skills__content {\n    width: 50% !important;\n\n    .icon {\n      margin: 0 1.5rem !important;\n    }\n  }\n\n  .sphere {\n    height: calc(tokens.$shapeSize * 1.15) !important;\n    right: 20% !important;\n    top: 15% !important;\n    width: calc(tokens.$shapeSize * 1.15) !important;\n  }\n}\n\n@media screen and (min-width: 1441px) {\n  #about__content,\n  #skills {\n    padding: 0 !important;\n  }\n}\n\n//** Height\n@media screen and (max-height: 320px) {\n  .cube__wrapper {\n    bottom: 40% !important;\n    transform: scale(0.9);\n  }\n\n  .pyramid__wrapper {\n    bottom: 10% !important;\n  }\n\n  .sphere {\n    right: 12.5% !important;\n    top: 20% !important;\n  }\n}\n\n@media screen and (min-height: 576px) {\n  .cube__wrapper {\n    bottom: 25% !important;\n  }\n\n  .pyramid__wrapper {\n    bottom: 10% !important;\n  }\n}\n\n@media screen and (min-height: 1024px) {\n  #about {\n    padding: 25% 10% !important;\n  }\n\n  .cube__wrapper {\n    bottom: 35% !important;\n    left: 15% !important;\n  }\n\n  .pyramid__wrapper {\n    bottom: 15% !important;\n    right: 20% !important;\n    transform: scale(1.5) !important;\n  }\n\n  #shapes .title {\n    font-size: tokens.$fontSizeH3 !important;\n  }\n\n  .sphere {\n    height: calc(tokens.$shapeSize * 1.15) !important;\n    top: 22.5% !important;\n    width: calc(tokens.$shapeSize * 1.15) !important;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n:root {\n  --colorBgPrimary: rgb(37, 41, 50);\n  --colorBgSecondary: rgba(117, 117, 162, 0.6);\n  --colorContent: rgb(255, 255, 255);\n  --colorShadow: rgba(0, 0, 0, 0.2);\n  // Value set on about__btn click\n  --cubeSideTranslateZ: 0rem;\n  // Value set on skills__btn click\n  --pyramidTransform: rotateY(-45deg) rotateZ(-30deg);\n  // Value for cube and sphere\n  --shapeSize: 6rem;\n  // window.innerHeight (px) is passed onload\n  --vh: 100%;\n}\n\nbody {\n  background: tokens.$bodyBg;\n  color: tokens.$bodyColor;\n  font-family: tokens.$bodyFontFamily;\n  font-size: tokens.$bodyFontSize;\n  // Fallback\n  min-height: 100vh;\n  min-height: var(--vh);\n  overflow: hidden;\n}\n\na {\n  color: tokens.$bodyColor;\n}\n\nbutton {\n  background: none;\n  border: none;\n  color: tokens.$bodyColor;\n  cursor: pointer;\n  font-family: tokens.$bodyFontFamily;\n}\n\nheader {\n  position: fixed;\n  width: 100%;\n  z-index: tokens.$headerZIndex;\n}\n\nmain {\n  // Fallback\n  height: 100vh;\n  height: var(--vh);\n  overflow: hidden;\n  position: relative;\n}\n\np {\n  line-height: tokens.$bodyLineHeight;\n}\n\n// On page load only loader and shapes sections are visible\nsection {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n  width: 100%;\n\n  & > div {\n    padding: tokens.$sectionContentPadding;\n  }\n  \n  .section--top {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\nul {\n  list-style: none;\n}\n\n::-webkit-scrollbar {\n  width: tokens.$scrollbarWidth;\n\n  &-thumb {\n    background: tokens.$scrollbarBg;\n    border-radius: tokens.$scrollbarBorderRadius;\n  }\n}\n","@use \"sass:map\";\n@use \"./typography\";\n\n// Tokens store the value of properties declared in components partials, thus you can set most of the style directly from here\n// The only values missing are meant to be fixed or standard (e.g. a circle has border-radius: 50%, with no need for changes)\n\n//** Global Tokens\n$borderPrimary: 0.15rem solid var(--colorContent);\n\n$fontFamilyComfortaa: \"Comfortaa\", cursive;\n$fontFamilyGugi: \"Gugi\", cursive;\n\n$fontSizeH3: map.get(typography.$types, \"h3\");\n$fontSizeH4: map.get(typography.$types, \"h4\");\n$fontSizeT3: map.get(typography.$types, \"t3\");\n$fontSizeT4: map.get(typography.$types, \"t4\");\n$fontSizeT5: map.get(typography.$types, \"t5\");\n\n$shapeSize: var(--shapeSize);\n\n$transition150eo: all 150ms ease-out;\n$transitionTransform250eio: transform 250ms ease-in-out;\n\n$zIndexAbove1: 1;\n$zIndexAbove2: 2;\n\n//** Contestual Tokens\n$aboutGridTemplateColumns: 0 1fr;\n$aboutPadding: 4.5rem 1rem;\n$aboutContentMaxHeight: 60%;\n\n$backBtnMarginTop: 2rem;\n\n$bodyBg: var(--colorBgPrimary);\n$bodyColor: var(--colorContent);\n$bodyFontFamily: $fontFamilyComfortaa;\n$bodyFontSize: $fontSizeT4;\n$bodyLineHeight: 1.4;\n\n$colorPickerBorderRadius: 0.3rem;\n$colorPickerHeight: 2rem;\n$colorPickerTransition: $transition150eo;\n$colorPickerPointerBg: var(--colorBgSecondary);\n$colorPickerPointerWidth: 1rem;\n\n$contactEmailFontSize: 5vw;\n\n$cubeTransform: rotateY(-30deg);\n$cubeSideBorder: $borderPrimary;\n$cubeSideTransition: $transitionTransform250eio;\n$cubeSideTranslateZ: var(--cubeSideTranslateZ);\n$cubeWrapperBottom: 15%;\n$cubeWrapperLeft: 0;\n$cubeWrapperPerspective: 100rem;\n$cubeWrapperPerspectiveOrigin: 50% -250%;\n\n$cursorBorder: $borderPrimary;\n$cursorSize: 2rem;\n$cursorTransition: $transition150eo;\n$cursorZIndex: $zIndexAbove2;\n$cursorActiveBg: var(--colorContent);\n$cursorActiveTransform: scale(1.5);\n$cursorBeforeBg: var(--colorContent);\n$cursorBeforeSize: 0.3rem;\n\n$headerZIndex: $zIndexAbove1;\n$headerColorBg: linear-gradient(\n  -45deg,\n  var(--colorBgSecondary),\n  var(--colorContent)\n);\n$headerColorMargin: 0 1.5rem 0 0.5rem;\n$headerContentMargin: 1.75rem 1.75rem 0 1.75rem;\n$headerContentLeftFontSize: $fontSizeT3;\n$headerContentRightSize: 1rem;\n$headerLogoSize: 2rem;\n$headerLogoPathFill: var(--colorContent);\n$headerLogoTextMarginLeft: 1rem;\n\n$loaderBg: var(--colorContent);\n$loaderZIndex: $zIndexAbove2;\n\n$pyramidTransform: var(--pyramidTransform);\n$pyramidTransition: $transitionTransform250eio;\n$pyramidWrapperBottom: 3%;\n$pyramidWrapperRight: 5%;\n\n$scrollbarBg: var(--colorBgSecondary);\n$scrollbarBorderRadius: 0.5rem;\n$scrollbarWidth: 0.2rem;\n\n$sectionContentAnimationSlideY: -2rem;\n$sectionContentPadding: 0 1rem;\n\n$shapesMenuZIndex: $zIndexAbove1;\n$shapesMenuButtonFontSize: $fontSizeT5;\n$shapesMenuButtonMargin: 0 1rem;\n$shapesTitleFontSize: $fontSizeH4;\n$shapesTitleMaxWidth: 75%;\n\n$skillBorderBottom: $borderPrimary;\n$skillPadding: 0.75rem 0;\n$skillsMaxHeight: 81.5%;\n$skillsPadding: 6rem 0;\n$skillsWidth: 85%;\n$skillsIconMargin: 0 0.5rem;\n$skillsImgMargin: 0.5rem 0;\n$skillsImgSize: 2.75rem;\n$skillsProjectGap: 1rem;\n$skillsProjectMarginTop: 2rem;\n\n$sphereBg: linear-gradient(0.45turn, var(--colorContent), transparent);\n$sphereBoxShadow: inset -0.5rem -0.5rem 2rem var(--colorShadow);\n$sphereRight: 5%;\n$sphereTop: 15%;\n$sphereTransition: $transitionTransform250eio;\n\n$titleFontFamily: $fontFamilyGugi;\n$titleMargin: 0.75rem 0;\n","* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n","@use \"../abstracts/tokens\";\n\n#about {\n  align-items: initial;\n  display: grid;\n  grid-template-columns: tokens.$aboutGridTemplateColumns;\n  padding: tokens.$aboutPadding;\n  text-align: justify;\n\n  &__content {\n    max-height: tokens.$aboutContentMaxHeight;\n    overflow-y: auto;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.back__btn {\n  margin-top: tokens.$backBtnMarginTop;\n}\n","@use \"../abstracts/tokens\";\n\n.color-picker {\n  border-radius: tokens.$colorPickerBorderRadius;\n  display: none;\n  height: tokens.$colorPickerHeight;\n  overflow: hidden;\n  position: relative;\n  transition: tokens.$colorPickerTransition;\n  width: 0;\n\n  canvas {\n    height: 100%;\n    width: 100%;\n  }\n\n  .pointer {\n    background: tokens.$colorPickerPointerBg;\n    height: 100%;\n    left: calc(tokens.$colorPickerPointerWidth / 2);\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: tokens.$colorPickerPointerWidth;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n#contact {\n  .email {\n    display: block;\n    font-size: tokens.$contactEmailFontSize;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.cube__wrapper {\n  bottom: tokens.$cubeWrapperBottom;\n  left: tokens.$cubeWrapperLeft;\n  perspective: tokens.$cubeWrapperPerspective;\n  perspective-origin: tokens.$cubeWrapperPerspectiveOrigin;\n  position: absolute;\n\n  // Cube hidden on skills or contact click\n  [data-section] & {\n    display: none;\n  }\n  [data-section=\"about\"] & {\n    display: block;\n  }\n}\n\n.cube {\n  height: tokens.$shapeSize;\n  position: relative;\n  transform: tokens.$cubeTransform;\n  transform-style: preserve-3d;\n  width: tokens.$shapeSize;\n\n  .cube__side {\n    border: tokens.$cubeSideBorder;\n    height: 100%;\n    position: absolute;\n    transition: tokens.$cubeSideTransition;\n    width: 100%;\n\n    &--back {\n      top: 50%;\n      transform: translateZ(\n        calc((-1 * (tokens.$shapeSize / 2 + tokens.$cubeSideTranslateZ)))\n      );\n    }\n\n    &--bottom {\n      top: 100%;\n      transform: rotateX(90deg)\n        translateZ(calc(-1 * tokens.$cubeSideTranslateZ));\n    }\n\n    &--front {\n      top: 50%;\n      transform: translateZ(\n        calc(tokens.$shapeSize / 2 + tokens.$cubeSideTranslateZ)\n      );\n    }\n\n    &--left {\n      right: 50%;\n      top: 50%;\n      transform: rotateY(90deg)\n        translateZ(calc(-1 * tokens.$cubeSideTranslateZ));\n    }\n\n    &--right {\n      left: 50%;\n      top: 50%;\n      transform: rotateY(90deg) translateZ(tokens.$cubeSideTranslateZ);\n    }\n\n    &--top {\n      transform: rotateX(90deg) translateZ(tokens.$cubeSideTranslateZ);\n    }\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.cursor {\n  border: tokens.$cursorBorder;\n  border-radius: 50%;\n  // Not showing on mobile\n  display: none;\n  height: tokens.$cursorSize;\n  pointer-events: none;\n  position: fixed;\n  transform: translate(-50%, -50%);\n  // Related to $cursorActiveTransform\n  transform-origin: 150% 150%;\n  // Delay on mouse move\n  transition: tokens.$cursorTransition;\n  width: tokens.$cursorSize;\n  z-index: tokens.$cursorZIndex;\n\n  &::before {\n    background: tokens.$cursorBeforeBg;\n    border-radius: 50%;\n    content: \"\";\n    height: tokens.$cursorBeforeSize;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: tokens.$cursorBeforeSize;\n  }\n\n  &--active {\n    background: tokens.$cursorActiveBg;\n    mix-blend-mode: soft-light;\n    transform: tokens.$cursorActiveTransform;\n\n    &::before {\n      display: none;\n    }\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.header__content {\n  justify-content: space-between;\n  margin: tokens.$headerContentMargin;\n\n  &,\n  & > div {\n    align-items: center;\n    display: flex;\n  }\n\n  &--left {\n    font-size: tokens.$headerContentLeftFontSize;\n\n    a {\n      height: tokens.$headerLogoSize;\n    }\n  }\n\n  .color {\n    background: tokens.$headerColorBg;\n    border-radius: 50%;\n    display: none;\n    height: tokens.$headerContentRightSize;\n    margin: tokens.$headerColorMargin;\n    position: relative;\n    width: tokens.$headerContentRightSize;\n  }\n\n  .lang {\n    height: tokens.$headerContentRightSize;\n    position: relative;\n    width: tokens.$headerContentRightSize;\n  }\n\n  // color and lang checkbox\n  input {\n    cursor: pointer;\n    height: 100%;\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n  }\n\n  .logo {\n    height: 100%;\n    width: tokens.$headerLogoSize;\n\n    // Logo text hidden on mobile\n    &__text {\n      display: none;\n      margin-left: tokens.$headerLogoTextMarginLeft;\n    }\n\n    path {\n      fill: tokens.$headerLogoPathFill;\n    }\n  }\n}\n","@use \"../abstracts/tokens\";\n\n#loader {\n  animation: fadeOut 500ms forwards 3.5s;\n  background: tokens.$loaderBg;\n  opacity: 1;\n  visibility: visible;\n  z-index: tokens.$loaderZIndex;\n\n  path:nth-child(1) {\n    animation: loaderStroke 3s forwards ease-in-out;\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 1000;\n  }\n\n  path:nth-child(2) {\n    animation: loaderStroke 2s forwards ease-in-out 0.3s;\n    stroke-dasharray: 581.5840454101562;\n    stroke-dashoffset: 581.5840454101562;\n  }\n\n  path:nth-child(3) {\n    animation: loaderStroke 2s forwards ease-in-out 0.6s;\n    stroke-dasharray: 715.9073486328125;\n    stroke-dashoffset: 715.9073486328125;\n  }\n\n  svg {\n    animation: loaderScale 1s forwards ease-in-out 3s;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n// Base and side::before depend on these (fixed) values\n$pyramidSize: 5rem;\n$pyramidBeforeBorderWidth: 2.4rem;\n\n.pyramid__wrapper {\n  bottom: tokens.$pyramidWrapperBottom;\n  position: absolute;\n  right: tokens.$pyramidWrapperRight;\n\n  // Pyramid hidden on about or contact click\n  [data-section] & {\n    display: none;\n  }\n  [data-section=\"skills\"] & {\n    display: block;\n  }\n}\n\n.pyramid {\n  height: $pyramidSize;\n  position: relative;\n  transform: tokens.$pyramidTransform;\n  transform-style: preserve-3d;\n  transition: tokens.$pyramidTransition;\n  width: $pyramidSize;\n\n  .pyramid__base {\n    background: var(--colorBgPrimary);\n    border: 0.15rem solid var(--colorContent);\n    height: 100%;\n    position: absolute;\n    transform: rotateX(90deg) translateZ(-1.8rem);\n    width: 100%;\n  }\n\n  .pyramid__side {\n    border: calc($pyramidSize / 2) solid transparent;\n    border-bottom: $pyramidSize solid var(--colorContent);\n    border-top: 0;\n    position: absolute;\n\n    &::before {\n      border: $pyramidBeforeBorderWidth solid transparent;\n      border-bottom: calc($pyramidBeforeBorderWidth * 2) solid\n        var(--colorBgPrimary);\n      content: \"\";\n      left: calc(-1 * $pyramidBeforeBorderWidth);\n      position: absolute;\n      top: -2.25rem;\n    }\n\n    &--back {\n      transform: rotateX(-30deg);\n      transform-origin: calc($pyramidSize / 2) 0;\n    }\n\n    &--front {\n      transform: rotateX(30deg);\n      transform-origin: 0 0;\n    }\n\n    &--left {\n      transform: rotateZ(30deg) rotateY(90deg);\n      transform-origin: calc($pyramidSize / 2) 0;\n    }\n\n    &--right {\n      transform: rotateZ(-30deg) rotateY(90deg);\n      transform-origin: calc($pyramidSize / 2) 0;\n    }\n  }\n}\n","@use \"../abstracts/tokens\";\n\n#shapes {\n  opacity: 1;\n  text-align: center;\n  visibility: visible;\n\n  .title {\n    font-size: tokens.$shapesTitleFontSize;\n    max-width: tokens.$shapesTitleMaxWidth;\n\n    // Title hidden on about, skills or contact click\n    [data-section] & {\n      display: none;\n    }\n  }\n\n  .menu {\n    z-index: tokens.$shapesMenuZIndex;\n\n    // Menu hidden on about, skills or contact click\n    [data-section] & {\n      display: none;\n    }\n\n    button {\n      cursor: help;\n      font-size: tokens.$shapesMenuButtonFontSize;\n      margin: tokens.$shapesMenuButtonMargin;\n    }\n\n    ul {\n      display: flex;\n    }\n  }\n}\n","@use \"../abstracts/tokens\";\n\n#skills {\n  justify-content: initial;\n  padding: tokens.$skillsPadding;\n\n  &__content {\n    max-height: tokens.$skillsMaxHeight;\n    overflow-y: auto;\n    width: tokens.$skillsWidth;\n  }\n\n  .skill {\n    border-bottom: tokens.$skillBorderBottom;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: tokens.$skillPadding;\n  }\n\n  a {\n    display: block;\n  }\n\n  img {\n    margin: tokens.$skillsImgMargin;\n    max-height: tokens.$skillsImgSize;\n    max-width: tokens.$skillsImgSize;\n  }\n\n  .icon {\n    display: inline-block;\n    margin: tokens.$skillsIconMargin;\n    text-align: center;\n  }\n\n  .project {\n    align-items: center;\n    display: flex;\n    gap: tokens.$skillsProjectGap;\n    margin-top: tokens.$skillsProjectMarginTop;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.sphere {\n  background: tokens.$sphereBg;\n  border-radius: 50%;\n  box-shadow: tokens.$sphereBoxShadow;\n  height: calc(tokens.$shapeSize * 0.85);\n  position: absolute;\n  right: tokens.$sphereRight;\n  top: tokens.$sphereTop;\n  transition: tokens.$sphereTransition;\n  width: calc(tokens.$shapeSize * 0.85);\n\n  // Sphere hidden on about or skills click\n  [data-section] & {\n    display: none;\n  }\n  [data-section=\"contact\"] & {\n    display: block;\n  }\n}\n","@use \"../abstracts/tokens\";\n\n.title {\n  font-family: tokens.$titleFontFamily;\n  margin: tokens.$titleMargin;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
